import * as React from "react";
const SvgFolder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#7878FA"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m12 7-1-2H4L3 7v12h18V7zm7 2h-8.236l-1-2H5.236L5 7.472V17h14z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFolder;
